const navNavigation = [
    { path: 'shop', name: 'SHOP' },
    { path: 'games', name: 'GAMES' },
    { path: 'metaverse', name: 'METAVERSE' },
    { path: 'contact', name: 'CONTACT' },
];

export default navNavigation